<template>
  <div>
    <div class="position-relative mb-3">
      <div class="position-relative mb-3">
        <section class="section-profile-cover section-shaped my-0">
          <div
            class="shape shape-style-1 bg-gradient-darkgray shape-skew alpha-4"
          >
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </section>
        <section class="section-skew">
          <div class="container-section">
            <card shadow class="section-home">
              <div class="row row-grid align-items-center">
                <div
                  class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 text-right"
                >
                  <div class="title-product">
                    <h3>
                      نرم ‌افزار رزرو و نوبت دهی سرمد
                    </h3>

                    <p>
                      راهکاری ساده و کارآمد برای مدیریت نوبت دهی و رزروهای کسب و
                      کار شما
                    </p>
                    <p>
                      با استفاده از سیستم رزرو و نوبت دهی هوشمند آنلاین، با
                      چالش‌های نوبت دهی سنتی خداحافظی کنید و تمامی فرایندهای
                      مربوطه را به آسانی و در کمترین زمان ممکن مدیریت کنید. این
                      سیستم مدرن، ساده و کارآمد، تمامی نیازهای سازمان شما را
                      پوشش می‌دهد و تجربه‌ای بی‌نظیر برای مشتریان و کارکنان شما
                      فراهم می‌آورد.
                    </p>
                  </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                  <div class="img-main-page">
                    <img src="img/product/research-rafiki.svg" alt="" />
                  </div>
                </div>
              </div>
            </card>
          </div>
        </section>
      </div>
      <section class="section-tab-product">
        <div class="container-section">
          <tabs :fill="false" class="flex-column">
            <tab-pane key="tab1" class="section-product">
              <template slot="title">
                <h5>
                  مزایای استفاده از نرم افزار نوبت دهی و رزرو آنلاین
                </h5>
              </template>
              <b-row>
                <b-col
                  cols="12"
                  xl="12"
                  lg="12"
                  md="12"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <ul class="list-unstyled  list-tab mt-4">
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          بهبود دسترسی و راحتی کاربران
                        </h5>
                      </div>
                      <p class="pt-2">
                        رزرو نوبت در هر ساعتی از شبانه روز برای کاربران امکان
                        پذیر است.
                      </p>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          صرفه جویی در وقت
                        </h5>
                      </div>
                      <p class="pt-2">
                        با مشاهده زمان‌های خالی و انتخاب نوبت مناسب، مراجعین شما
                        زمان کمتری در انتظار خواهند بود.
                      </p>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          کاهش بار کاری پذیرش
                        </h5>
                      </div>
                      <p class="pt-2">
                        با اتوماسیون فرآیند نوبت‌دهی، کارکنان پذیرش می‌توانند بر
                        وظایف مهم‌تری مانند پیگیری جذب مشتری و بازاریابی تمرکز
                        کنند.
                      </p>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          زمان بندی دقیق
                        </h5>
                      </div>
                      <p class="pt-2">
                        برنامه‌ کاری و ساعات پذیرش هر یک از کارکنان شما با دقت
                        بالاتری مدیریت می‌شود.
                      </p>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          کاهش خطا و اشتباهات
                        </h5>
                      </div>
                      <p class="pt-2">
                        احتمال بروز اشتباهات انسانی را به حداقل می‌رساند و
                        وارسال پیامک یا ایمیل یادآور به مراجعین، میزان نوبت‌های
                        فراموش شده را کاهش می‌دهد.
                      </p>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          ارتباط با مشتریان
                        </h5>
                      </div>
                      <p class="pt-2">
                        پیام‌های شخصی‌سازی شده و یادآوری‌های خودکار، ارتباطات
                        بین سازمان شما و مشتریان را تقویت می‌کند و رضایت مشتریان
                        از خدمات ارائه شده را افزایش می‌دهد.
                      </p>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          دسترسی به داده‌ها و تحلیل‌های دقیق
                        </h5>
                      </div>
                      <p class="pt-2">
                        ابزارهای گزارش‌دهی و تحلیل، عملکرد سازمان را به‌طور جامع
                        ارزیابی می‌کند و مدیریت داده‌های دقیق و به‌روز،
                        تصمیم‌گیری‌ بهتر را ممکن می‌سازد
                      </p>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          افزایش درآمد و کاهش هزینه‌ها
                        </h5>
                      </div>
                      <p class="pt-2">
                        بهینه‌سازی فرایند نوبت دهی با کاهش نوبت‌های لغو شده و
                        بهبود مدیریت زمان، تعداد مراجعین پذیرش شده را افزایش
                        می‌دهد و منجر به کاهش هزینه‌های عملیاتی می‌گردد.
                      </p>
                    </li>
                  </ul>
                </b-col>
              </b-row>
            </tab-pane>
            <tab-pane key="tab2" class="section-product">
              <template slot="title">
                <h5>
                  قابلیت‌های نرم افزار رزرو و نوبت دهی سرمد
                </h5>
              </template>
              <b-row>
                <b-col
                  cols="12"
                  xl="12"
                  lg="12"
                  md="12"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <ul class="list-unstyled  list-tab mt-4">
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          تعریف انواع خدمات و تخصص‌ها و ثبت و دسته بندی افراد
                          ارائه دهنده خدمت یا متخصصان مجموعه
                        </h5>
                      </div>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          تعیین شیفت اختصاصی برای هر یک از کارکنان، متناسب با
                          ساعات کاری هر فرد
                        </h5>
                      </div>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          تعریف بازه زمانی مشخص هر وعده نوبت
                        </h5>
                      </div>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          تعریف روزهای کاری و تعطیل برای خدمات یا افراد ارائه
                          دهنده خدمت
                        </h5>
                      </div>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          تولید انواع گزارش های دلخواه، متناسب با نیازهای سازمان
                          شما
                        </h5>
                      </div>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          تعریف و مدیریت پیش پرداخت جهت ثبت نهایی رزرو
                        </h5>
                      </div>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          ارسال پیامک یا ایمیل یادآور برای مراجعین، با نزدیک شدن
                          به زمان رزرو ثبت شده
                        </h5>
                      </div>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          تعریف و مدیریت جلسات آنلاین ویزیت و مشاوره به صورت
                          تصویری و متنی در بستری امن و یکپارچه
                        </h5>
                      </div>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          قابلیت اتصال به سیستم مدیریت ارتباط با مشتری (CRM) و
                          باشگاه مشتریان
                        </h5>
                      </div>
                    </li>
                  </ul>
                </b-col>
              </b-row>
            </tab-pane>
          </tabs>
        </div>
      </section>
    </div>
    <button v-if="showScrollButton" @click="scrollToTop" class="scroll-to-top">
      <i class="fa fa-arrow-up" aria-hidden="true"></i>
    </button>
  </div>
</template>
<script>
import Tabs from "@/components/Tabs/Tabs.vue";
import TabPane from "@/components/Tabs/TabPane.vue";

export default {
  name: "Reservation",
  components: {
    Tabs,
    TabPane,
  },
  data() {
    return {
      showScrollButton: false,
    };
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    handleScroll() {
      this.showScrollButton = window.scrollY > 300;
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
